import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { ButtonBase, ButtonBaseProps, lighten, Theme } from '@mui/material';
import { MdOutlinePlayCircleFilled as ArrowCircleRightIcon } from 'react-icons/md';
import { MdFilterAlt as FilterAltIcon } from 'react-icons/md';
import { important } from 'common-types';

const SidebarButton: FC<
  React.PropsWithChildren<SidebarButtonProps>
> = props => {
  const { classes } = useStyles();
  return (
    <ButtonBase {...props} className={classes.openButton}>
      <FilterAltIcon />
      <ArrowCircleRightIcon />
    </ButtonBase>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  openButton: {
    minHeight: '50px',
    minWidth: '40px',
    borderTopRightRadius: important('10px'),
    borderBottomRightRadius: important('10px'),
    boxShadow: '0px 1px 7px rgba(0, 0, 0, 0.1)',
    color: important(lighten(theme.palette.text.primary, 0.5)),
    backgroundColor: important(theme.palette.background.paper),
    paddingInline: important(theme.spacing(1)),
    '& > svg': {
      fontSize: '1rem',
    },
  },
}));

export interface SidebarButtonProps extends ButtonBaseProps {}

export default SidebarButton;
